import React, {Fragment, Component} from 'react';
import PropTypes from 'prop-types';
import GamesList from './GamesList';
import {Modal, Button, Panel, PeopleOnline} from '../common';
import NewGameModal from './NewGameModal';
import {appId} from '../../store';
import AblyService from '../../utils/ably';
import {ON_MODAL_OPEN, ON_MODAL_CLOSE, ON_API_ERROR} from '../../actions/types';
import {
  ABLY_EVENT_GAME_CREATED,
  ABLY_EVENT_GAME_UPDATED,
  ABLY_ERROR,
} from '../../configs/constants';

export default class Lobby extends Component {
  static propTypes = {
    branchIoLink: PropTypes.string,
    createGame: PropTypes.func.isRequired,
    onConfirmMedia: PropTypes.func.isRequired,
    isModalOpened: PropTypes.bool,
    list: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    onFetchGames: PropTypes.func.isRequired,
    hasMore: PropTypes.bool,
    query: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    updateGame: PropTypes.func.isRequired,
    onGameCreated: PropTypes.func.isRequired,
    onJoinGame: PropTypes.func.isRequired,
    playerLimit: PropTypes.number,
    isLandingShowed: PropTypes.bool,
    gameConfig: PropTypes.shape({
      playerLimit: PropTypes.number.isRequired,
      isAudienceAllowed: PropTypes.bool,
      isPublished: PropTypes.bool,
    }).isRequired,
    currentTeamDefinition: PropTypes.shape({
      leftTeamName: PropTypes.string,
      rightTeamName: PropTypes.string,
      playerDefinition: PropTypes.arrayOf(PropTypes.string),
      teamDefinition: PropTypes.shape({
        preselected: PropTypes.string,
        field: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string),
      }),
    }).isRequired,
    fetchGameTeamDefinition: PropTypes.func.isRequired,
    fetchMobileBranchIoLink: PropTypes.func.isRequired,
    saveUserDefinitions: PropTypes.func.isRequired,
    fetchingCurrentTeamDefinition: PropTypes.bool.isRequired,
    ableToSendGiftsForFree: PropTypes.bool,
    onPlayerEnteredGameByDirectLink: PropTypes.func.isRequired,
    user: PropTypes.shape({}).isRequired,
    sidebarToggle: PropTypes.func.isRequired,
  };

  static defaultProps = {
    ableToSendGiftsForFree: false,
    branchIoLink: '',
    list: [],
    isModalOpened: false,
    isLandingShowed: false,
    hasMore: true,
    query: '',
    playerLimit: 4,
  };

  componentDidMount() {
    const {onGameCreated, updateGame, onFetchGames} = this.props;
    if (AblyService.realtime) {
      this.channelApp = AblyService.realtime.channels.get(`app/${appId}`);
      // ably v2: filter by message.name instead of subscribing per event name.
      // Retain each listener reference so it can be torn down selectively via
      // channel.unsubscribe(listener) in componentWillUnmount.
      // Pass the whole message: onGameCreated/updateGame/logAblyError each
      // destructure `message.data` internally, matching the v1 named-subscribe
      // behaviour where the listener received the full Ably Message.
      this.onGameCreatedListener = (message) => {
        if (message.name === ABLY_EVENT_GAME_CREATED) {
          onGameCreated(message);
        }
      };
      this.onGameUpdatedListener = (message) => {
        if (message.name === ABLY_EVENT_GAME_UPDATED) {
          updateGame(message);
        }
      };
      this.onAblyErrorListener = (message) => {
        if (message.name === ABLY_ERROR) {
          this.logAblyError(message);
        }
      };
      this.channelApp.subscribe(this.onGameCreatedListener);
      this.channelApp.subscribe(this.onGameUpdatedListener);
      this.channelApp.subscribe(this.onAblyErrorListener);
    }
    onFetchGames({resetPage: true, query: ''});
  }

  componentWillUnmount() {
    if (this.channelApp) {
      // ably v2: unsubscribe by the retained listener references.
      this.channelApp.unsubscribe(this.onGameCreatedListener);
      this.channelApp.unsubscribe(this.onGameUpdatedListener);
      this.channelApp.unsubscribe(this.onAblyErrorListener);
    }
  }

  onModalClose = () => {
    const {dispatch} = this.props;
    dispatch({type: ON_MODAL_CLOSE});
  }

  onPopupShow = () => {
    const {dispatch} = this.props;
    dispatch({type: ON_MODAL_OPEN});
  }

  onFormSubmit = (data) => {
    const {createGame} = this.props;
    createGame(data, appId);
  }

  onSidebarToggle = () => {
    const {sidebarToggle} = this.props;

    sidebarToggle({status: true});
  }

  logAblyError = (error) => {
    const {dispatch} = this.props;
    const {data: {message}} = error;
    dispatch({type: ON_API_ERROR, error: message});
  }

  renderLink = () => (
    <Fragment>
      <Button
        text="Create new game"
        size="l"
        icon="plus"
        theme="secondary"
        className="new-game-btn button_rounded"
        handler={this.onPopupShow}
      />
      <Button
        size="l"
        icon="bars"
        className="top-menu-btn"
        handler={this.onSidebarToggle}
      />
    </Fragment>
  );

  render() {
    const {
      branchIoLink,
      list,
      hasMore,
      onFetchGames,
      isModalOpened,
      query,
      gameConfig,
      onJoinGame,
      isLandingShowed,
      onConfirmMedia,
      fetchGameTeamDefinition,
      fetchMobileBranchIoLink,
      currentTeamDefinition,
      fetchingCurrentTeamDefinition,
      onPlayerEnteredGameByDirectLink,
      ableToSendGiftsForFree,
      saveUserDefinitions,
      user,
      dispatch,
    } = this.props;

    const {isPublished} = gameConfig;
    const titleText = isPublished ? 'Let’s get started!' : 'We\'re sorry...';

    return (
      <Panel
        title="Welcome to the lobby"
        subtitle="Select a game below to get started."
        size="l"
        headerSize="l"
        renderActions={this.renderLink()}
        cls="lobby-page"
      >
        <div className="row row_space-between">
          <div className="cell">
            <GamesList
              branchIoLink={branchIoLink}
              gameList={list}
              hasMore={hasMore}
              onFetchGames={onFetchGames}
              onJoinGame={onJoinGame}
              gameConfig={gameConfig}
              onConfirmMedia={onConfirmMedia}
              isLandingShowed={isLandingShowed}
              query={query}
              fetchGameTeamDefinition={fetchGameTeamDefinition}
              ableToSendGiftsForFree={ableToSendGiftsForFree}
              saveUserDefinitions={saveUserDefinitions}
              fetchingCurrentTeamDefinition={fetchingCurrentTeamDefinition}
              fetchMobileBranchIoLink={fetchMobileBranchIoLink}
              onPlayerEnteredGameByDirectLink={onPlayerEnteredGameByDirectLink}
              currentTeamDefinition={currentTeamDefinition}
              user={user}
              dispatch={dispatch}
            />
          </div>
          <div className="cell cell_auto">
            <PeopleOnline/>
          </div>
        </div>
        <Modal
          title={titleText}
          isOpen={isModalOpened}
          onClose={this.onModalClose}
          contentStyles="modal__content_bare modal__new-game"
        >
          <NewGameModal
            onFormSubmit={this.onFormSubmit}
            gameConfig={gameConfig}
          />
        </Modal>
      </Panel>
    );
  }
}
